import React, { ChangeEvent } from "react";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { toast } from "react-toastify";
import { ContactNumber, Continue, DescribeIssue, Email, Previous } from "../../../../../../../constants";
import { ActiveCallbackProp, InquiriesFormData } from "../../../../../../../types/Forms";
import { ItemsNameList } from "../../../../../../../data/formsAndTable/forms/FormLayout";
import { useForm } from "react-hook-form";

const InquiresForm: React.FC<ActiveCallbackProp> = ({ activeCallBack, differentId }) => {
  const {
    register,
    formState: { errors },
    setValue,
    watch,
    handleSubmit,
  } = useForm<InquiriesFormData>({});

  const formData = watch();

  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.name as keyof InquiriesFormData, event.target.value, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handleNextButton = handleSubmit(
    () => {
      if (formData.notifications !== "" && formData.email !== "" && formData.contactNumber !== "" && formData.describeIssue !== "") activeCallBack(4);
    },
    () => {
      toast.error("Please fill out all the fields before moving on to the next step");
    }
  );
  return (
    <Form onSubmit={(event) => event.preventDefault()} className="needs-validation" noValidate>
      <Row className="g-3">
        <Col xs="12" className="inquiries-form">
          <Row>
            <Col md="6">
              <p className="f-w-500">{"Select the option how you want to receive important notifications."}</p>
              <div className="choose-option">
                {ItemsNameList.map((data, index) => (
                  <FormGroup check key={index} className="radio radio-primary">
                    <Input {...register("notifications", { required: "Notifications option is required" })} className="me-2" id={differentId ? data : `${data + index}`} type="radio" onChange={updateFormData} checked={formData.notifications === data} value={data} />
                    <Label htmlFor={differentId ? data : `${data + index}`} check>
                      {data}
                    </Label>
                  </FormGroup>
                ))}
                {errors.notifications && <span className="text-danger">{errors.notifications.message}</span>}
              </div>
            </Col>
            <Col md="6">
              <Row className="g-3">
                <Col xs="12">
                  <Label>
                    {Email}
                    <span className="txt-danger">*</span>
                  </Label>
                  <Input {...register("email", { required: "Email is required" })} type="email" placeholder="org@support.com" value={formData.email} onChange={updateFormData} />
                  {errors.email && <span className="text-danger">{errors.email.message}</span>}
                </Col>
                <Col xs="12">
                  <Label>{ContactNumber}</Label>
                  <Input {...register("contactNumber", { required: "Contact number is required" })} type="number" placeholder="Enter number" value={formData.contactNumber} onChange={updateFormData} />
                  {errors.contactNumber && <span className="text-danger">{errors.contactNumber.message}</span>}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs="12">
          <Label className="f-w-500">{DescribeIssue}</Label>
          <Input {...register("describeIssue", { required: "Issue Description is required" })} type="textarea" rows={3} value={formData.describeIssue} onChange={updateFormData} />
          {errors.describeIssue && <span className="text-danger">{errors.describeIssue.message}</span>}
        </Col>
        <Col xs="12" className="text-end">
          <Button color="primary" className="me-2" onClick={() => activeCallBack(2)}>
            {Previous}
          </Button>
          <Button color="primary" onClick={handleNextButton}>
            {Continue}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default InquiresForm;
